import Dropdown from "../../../common/dropdown";
import Accordion from "../../../common/accordion";
import { useAppSelector } from "../../../../store/hooks/StoreHooks";
import useCollapseFacade from "../../../../facade/collapse.Facade";
import useProtectorFacade from "../../../../facade/calculation/calculation-output/protector.facade";
import { ProtectorListProps } from "../../../../store/model/calculations/protector";
import { Info } from "../../../../assets/icons";
import { useEffect } from "react";

const OilContractions: React.FC<ProtectorListProps> = ({ showError, setShowError }) => {

    const { oilContractionsCollapse } = useAppSelector(
        (state) => state?.collapse
    );
    const { OilContractionList, oilType, selectedLowerProtector, selectedUpperProtector } = useAppSelector((state) => state?.protector)
    const { tab1Input } = useAppSelector((state) => state?.tubing);
    const { MotorperformanceList, MotorOilWarning } = useAppSelector((state) => state?.motor);

    let oilList: { id: string; name: string }[] = Object.entries(oilType || [])
        .map(([key, value]) => ({ id: value as string, name: key }))

    useEffect(() => {
        if (MotorperformanceList[0]?.opeatngTemp > MotorOilWarning?.MaxTemp || MotorperformanceList[0]?.opeatngTemp < MotorOilWarning?.MinTemp) {
            if (!showError?.includes("Selected oil type not suitable with expected motor operating temperature."))
                setShowError((prevState: any) => [...prevState, "Selected oil type not suitable with expected motor operating temperature."]);
        } else {
            setShowError((prevState: any) =>
                prevState.filter((error: any) => error !== "Selected oil type not suitable with expected motor operating temperature.")
            );
        }
    }, [MotorperformanceList, MotorOilWarning])

    const { updateOilProtectionsCollapse } = useCollapseFacade();
    const { updateSelectedOilType, loadOilContraction } = useProtectorFacade();

    const handleCollapseChange = (key: boolean) => {
        updateOilProtectionsCollapse(key);
    };

    const handleSelect = (option: any) => {
        updateSelectedOilType(option?.id)
        loadOilContraction({})
    };

    return (
        <Accordion
            tooltipText="Formulas"
            title="Oil contraction"
            link={'/help?tab=Protector#OilContraction'}
            isOpen={oilContractionsCollapse}
            onToggle={() => handleCollapseChange(!oilContractionsCollapse)}
            content={
                <div className="p-[16px] flex flex-col">
                    <div className="flex items-center gap-[12px] pb-[16px]">
                        <label className="text-[14px] font-semibold text-neutral-25">
                            Motor Oil Type
                        </label>
                        <Dropdown
                            options={oilList || []}
                            onSelect={(option) => handleSelect(option)}
                            dropdownBgColor="bg-darkcolor-800"
                            bgColor="bg-transparent"
                            width="170px"
                            selected={tab1Input?.hdnProtector_OilType}
                        />
                    </div>
                    <div className="flex p-[12px] gap-[12px] rounded-[8px] border-[1px] bg-primary-600 border-darkcolor-400 mb-2">
                        <Info className="mr-2" />
                        <p className="text-[14px] font-bold leading-[20px] text-neutral-25">
                            <strong>Note: </strong>  Oil expansion requires motor to be selected.
                        </p>
                    </div>
                    {
                        (Object.keys(selectedLowerProtector)?.length > 0 || Object.keys(selectedUpperProtector)?.length > 0) &&
                        <div className={`scrollable max-h-[400px] relative overflow-auto`}>
                            <table className="min-w-full rounded-[8px] outline-[1px] table">
                                <thead style={{ background: "transparent" }}>
                                    <tr>
                                        <th className="px-[24px] py-[16px] text-[12px] text-neutral-25"></th>
                                        <th className="px-[24px] py-[16px] text-[12px] text-neutral-25">
                                            <div className="flex items-center">Operation (%)</div>
                                        </th>
                                        <th className="px-[24px] py-[16px] text-[12px] text-neutral-25">
                                            <div className="flex items-center">Pull (%)</div>
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td className="px-[24px] py-[16px] text-neutral-25 text-[14px]">
                                            LT Chamber #1 Contraction
                                        </td>
                                        <td className="px-[24px] py-[16px] text-neutral-25 text-[14px]">
                                            {OilContractionList?.operation_LTChamber1Contraction}
                                        </td>
                                        <td className="px-[24px] py-[16px] text-neutral-25 text-[14px]">
                                            {OilContractionList?.pull_LTChamber1Contraction}
                                        </td>
                                    </tr>
                                    <tr>
                                        <td className="px-[24px] py-[16px] text-neutral-25 text-[14px]">
                                            LT Chamber #2 Contraction
                                        </td>
                                        <td className="px-[24px] py-[16px] text-neutral-25 text-[14px]">
                                            {OilContractionList?.operation_LTChamber2Contraction}
                                        </td>
                                        <td className="px-[24px] py-[16px] text-neutral-25 text-[14px]">
                                            {OilContractionList?.pull_LTChamber2Contraction}
                                        </td>
                                    </tr>
                                    <tr>
                                        <td className="px-[24px] py-[16px] text-neutral-25 text-[14px]">
                                            LT Chamber #3 Contraction
                                        </td>
                                        <td className="px-[24px] py-[16px] text-neutral-25 text-[14px]">
                                            {OilContractionList?.operation_LTChamber3Contraction}
                                        </td>
                                        <td className="px-[24px] py-[16px] text-neutral-25 text-[14px]">
                                            {OilContractionList?.pull_LTChamber3Contraction}
                                        </td>
                                    </tr>
                                    <tr>
                                        <td className="px-[24px] py-[16px] text-neutral-25 text-[14px]">
                                            UT Chamber #1 Contraction
                                        </td>
                                        <td className="px-[24px] py-[16px] text-neutral-25 text-[14px]">
                                            {OilContractionList?.operation_UTChamber1Contraction}
                                        </td>
                                        <td className="px-[24px] py-[16px] text-neutral-25 text-[14px]">
                                            {OilContractionList?.pull_UTChamber1Contraction}
                                        </td>
                                    </tr>
                                    <tr>
                                        <td className="px-[24px] py-[16px] text-neutral-25 text-[14px]">
                                            UT Chamber #2 Contraction
                                        </td>
                                        <td className="px-[24px] py-[16px] text-neutral-25 text-[14px]">
                                            {OilContractionList?.operation_UTChamber2Contraction}
                                        </td>
                                        <td className="px-[24px] py-[16px] text-neutral-25 text-[14px]">
                                            {OilContractionList?.pull_UTChamber2Contraction}
                                        </td>
                                    </tr>
                                    <tr>
                                        <td className="px-[24px] py-[16px] text-neutral-25 text-[14px]">
                                            UT Chamber #3 Contraction
                                        </td>
                                        <td className="px-[24px] py-[16px] text-neutral-25 text-[14px]">
                                            {OilContractionList?.operation_UTChamber3Contraction}
                                        </td>
                                        <td className="px-[24px] py-[16px] text-neutral-25 text-[14px]">
                                            {OilContractionList?.pull_UTChamber3Contraction}
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    }
                </div>
            }
        />
    );
};

export default OilContractions;
